export const locale = {
  lang: 'de',
  data: {
    CONFIRM: 'Bestätigung',
    OK: 'OK',
    CANCEL: 'Abbrechen'
  }
};
